import { Avatar, Stack, Text } from "@skailer-com/uikit";
import { ReactNode } from "react";

export interface InformBoxProps {
  title: string;
  description?: string;
  emoji?: string;
  titleClassName?: string;
  actionsSlot?: ReactNode;
}

export function InformBox({
  title,
  description,
  emoji = "bulb",
  titleClassName = "text-warning",
  actionsSlot,
}: InformBoxProps) {
  return (
    <Stack className={"rounded-sm border-dark/5 bg-dark/5 p-4 border"} gap={"sm"}>
      <Stack direction={"horizontal"} gap={"sm"}>
        <Avatar emoji={emoji} size={"sm"} />
        <Text className={`font-semibold ${titleClassName}`}>{title}</Text>
      </Stack>
      {description && <Text>{description}</Text>}
      {actionsSlot && actionsSlot}
    </Stack>
  );
}
